import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";
import Connector from "@helpers/Connector";

import Style from "./EventCancel.module.scss";

interface PropsInterface {
  callback: any;
  data: any;
}

interface StateInterface {
  reason: string;
  isCanceled: boolean;
}

export default Connector(
  class Default extends React.Component<PropsInterface, StateInterface> {
    public reasons = [
      "Предлагаю другое время",
      "Не располагаю временем",
      "Я не владею информацией по теме встречи",
      "Предлагаю изменить длительность встречи",
      "Не могу указать причину",
    ];

    public constructor(props: PropsInterface) {
      super(props);
      this.state = {
        reason: "",
        isCanceled: false,
      };

      this.onSubmitHandler = this.onSubmitHandler.bind(this);
      this.onChangeHandler = this.onChangeHandler.bind(this);
    }

    private onChangeHandler(event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>): void {
      this.setState({ [event.target.name]: event.target.value });
    }

    private onSubmitHandler(event: React.FormEvent<HTMLFormElement>): void {
      event.preventDefault();

      if (this.props.data.isOwner) {
        Middleware.User.Event.remove(this.props.data.id, {
          description: this.state.reason,
        }).then(() => {
          // Middleware.Ui.Modal.closeAll();
          Middleware.User.Event.list();
          Middleware.Ui.Alert.open("Default", {
            text: "Событие отменено",
          });
          if (this.props.callback) {
            this.props.callback();
          }

          this.setState({ isCanceled: true });
          // Middleware.Ui.Modal.closeAll();
        });
        Middleware.User.Event.reject(this.props.data.id, {
          description: this.state.reason,
        }).then(() => {
          // Middleware.Ui.Modal.closeAll();
          Middleware.User.Event.list();
          if (this.props.callback) {
            this.props.callback();
          }

          this.setState({ isCanceled: true });
          // Middleware.Ui.Modal.closeAll();
        });
        // .catch(() => {
        //   Middleware.Ui.Alert.open("Default", {
        //     text: "Ошибка",
        //   });
        // });
      } else {
        Middleware.User.Event.reject(this.props.data.id, {
          description: this.state.reason,
        }).then(() => {
          // Middleware.Ui.Modal.closeAll();
          Middleware.User.Event.list();
          Middleware.Ui.Alert.open("Default", {
            text: "Событие отменено",
          });
          if (this.props.callback) {
            this.props.callback();
          }

          this.setState({ isCanceled: true });
          // Middleware.Ui.Modal.closeAll();
        });
        Middleware.User.Event.remove(this.props.data.id, {
          description: this.state.reason,
        }).then(() => {
          // Middleware.Ui.Modal.closeAll();
          Middleware.User.Event.list();
          if (this.props.callback) {
            this.props.callback();
          }
          this.setState({ isCanceled: true });
          // Middleware.Ui.Modal.closeAll();
        });
        // .catch(() => {
        //   Middleware.Ui.Alert.open("Default", {
        //     text: "Ошибка",
        //   });
        // });
      }
    }

    public render() {
      return (
        <>
          <div className="modal modal--event-cancel">
            <form onSubmit={this.onSubmitHandler}>
              <div className="modal__header">
                <div className="modal__title">Отмена события</div>
                <button
                  className="modal__close"
                  onClick={() => {
                    Middleware.Ui.Modal.close();
                  }}
                />
              </div>
              <div className="modal__body">
                {this.state.isCanceled ? (
                  <div className="modal__desc">Встреча отменена</div>
                ) : (
                  <>
                    <div className="modal__desc">
                      Обязательно напишите, почему вы отменяете встречу или воспользуйтесь готовыми
                      вариантами:
                    </div>
                    <div className={Style.container}>
                      {this.reasons.map((reason: string, index: number) => (
                        <Link
                          to="#"
                          key={index}
                          onClick={(e) => {
                            e.preventDefault();
                            this.setState({ reason });
                          }}
                        >
                          {reason}
                        </Link>
                      ))}
                    </div>
                    <div className="textarea">
                      <textarea
                        className="textarea__input"
                        name="reason"
                        onChange={this.onChangeHandler}
                        maxLength={300}
                        value={this.state.reason}
                        required
                      />
                      <div className="textarea__counter">
                        {300 - this.state.reason.length} знаков
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="modal__footer">
                {this.state.isCanceled ? (
                  <>
                    <Link
                      className="btn btn--grey"
                      to="#"
                      onClick={() => {
                        Middleware.Ui.Modal.closeAll();
                      }}
                    >
                      Вернуться в календарь
                    </Link>
                  </>
                ) : (
                  <>
                    <button type="submit" className="btn btn--blue-white">
                      Отправить
                    </button>
                    <Link
                      className="btn btn--grey"
                      to="#"
                      onClick={() => {
                        Middleware.Ui.Modal.close();
                      }}
                    >
                      Назад
                    </Link>
                  </>
                )}
              </div>
            </form>
          </div>
        </>
      );
    }
  }
);
